<template>
  <div class="wrapper">
    <div class="topo-header centro">
      <botao-voltar nomeRota="Acompanhamentos" />
      <h1>{{ acompanhamentoForm.id ? "Editar" : "Nova" }} Movimentação</h1>
    </div>

    <div class="form centro">
      <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
      <p class="texto-asterisco">Os campos com asterisco (*) são de preenchimento obrigatório.</p>
      
      <form @submit.prevent="enviarForm">
        
        <!-- BLOCO 1: DADOS BÁSICOS -->
        <h2 class="titulo-bloco">1. Dados Básicos</h2>
        <div class="caixa-form item">
          <div class="flexbox">
            <div class="item">
              <div class="radio">
                <label class="radio-label"><b>{{ possuiAsterisco("Tipo de Movimentação:") }}</b></label>
                <div class="radio-item">
                  <div class="options">
                    <input type="radio" id="indicacao" value="indicacao" v-model="acompanhamentoForm.tipo_movimentacao">
                    <label for="indicacao">Indicação</label>
                  </div>
                  <div class="options">
                    <input type="radio" id="destituicao" value="destituicao" v-model="acompanhamentoForm.tipo_movimentacao">
                    <label for="destituicao">Destituição</label>
                  </div>
                  <div class="options">
                    <input type="radio" id="substituicao" value="substituicao" v-model="acompanhamentoForm.tipo_movimentacao">
                    <label for="substituicao">Substituição</label>
                  </div>
                  <div class="options">
                    <input type="radio" id="exoneracao" value="exoneracao" v-model="acompanhamentoForm.tipo_movimentacao">
                    <label for="exoneracao">Exoneração</label>
                  </div>
                  <div class="options">
                    <input type="radio" id="reconducao" value="reconducao" v-model="acompanhamentoForm.tipo_movimentacao">
                    <label for="reconducao">Recondução</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flexbox">
            <div class="item">
              <label><b>Processo SEI:</b></label>
              <input type="text" placeholder="Número do processo administrativo" v-model="acompanhamentoForm.processo_sei" />
            </div>
            
            <div class="item">
              <label><b>{{ possuiAsterisco("Órgão:") }}</b></label>
              <v-select
                class="vselect"
                v-model="selectedOrgaoGlobal"
                :options="categorias"
                label="nome"
                placeholder="Selecione o órgão correspondente"
                :filterable="true">
              </v-select>
            </div>
          </div>

          <div class="flexbox" v-if="['indicacao', 'substituicao', 'reconducao'].includes(acompanhamentoForm.tipo_movimentacao)">
            <div class="item">
              <label><b>{{ possuiAsterisco("CPF Indicado:") }}</b></label>
              <the-mask 
                  v-model="acompanhamentoForm.cpf_indicado" 
                  :mask="['###.###.###-##']" 
                  placeholder="000.000.000-00"
              />
            </div>
            <div class="item">
              <label><b>{{ possuiAsterisco("Nome Indicado:") }}</b></label>
              <input type="text" 
                placeholder="Insira o nome do indicado" 
                v-model="acompanhamentoForm.nome_indicado" 
                :readonly="bloquearNomeIndicado"
                :class="{ 'input-bloqueado': bloquearNomeIndicado }" />
            </div>
              <div class="item">
                <label><b>Conselho do Indicado:</b></label>
                <v-select
                  class="vselect"
                  v-model="selectedConselhoIndicado"
                  :options="conselhosFiltrados"
                  label="nome"
                  placeholder="Selecione o conselho"
                  :disabled="!selectedOrgaoGlobal"
                  :filterable="true">
                </v-select>
              </div>
            <div class="item">
              <label><b>Cargo do Indicado:</b></label>
              <v-select
                class="vselect"
                v-model="selectedCargoIndicado"
                :options="cargos"
                label="nome"
                placeholder="Selecione o cargo colegiado"
                :filterable="true">
              </v-select>
            </div>
          </div>

          <div class="flexbox" v-if="['destituicao', 'substituicao', 'exoneracao'].includes(acompanhamentoForm.tipo_movimentacao)">
            <div class="item">
              <label><b>{{ possuiAsterisco(labelCpfSaida) }}</b></label>
              <the-mask 
                  v-model="acompanhamentoForm.cpf_destituido" 
                  :mask="['###.###.###-##']" 
                  placeholder="000.000.000-00"
              />
            </div>
            <div class="item">
              <label><b>{{ possuiAsterisco(labelNomeSaida) }}</b></label>
              <input type="text" 
                :placeholder="'Insira o ' + labelNomeSaida.replace(':', '').toLowerCase()" 
                v-model="acompanhamentoForm.nome_destituido" 
                :readonly="bloquearNomeDestituido"
                :class="{ 'input-bloqueado': bloquearNomeDestituido }" />
            </div>
              <div class="item">
                <label><b>Conselho do {{ labelNomeSaida.replace('Nome ', '').replace(':', '') }}:</b></label>
                <v-select
                  class="vselect"
                  v-model="selectedConselhoDestituido"
                  :options="conselhosFiltrados"
                  label="nome"
                  placeholder="Selecione o conselho"
                  :disabled="!selectedOrgaoGlobal"
                  :filterable="true">
                </v-select>
              </div>
            <div class="item">
              <label><b>Cargo do {{ labelNomeSaida.replace('Nome ', '').replace(':', '') }}:</b></label>
              <v-select
                class="vselect"
                v-model="selectedCargoDestituido"
                :options="cargos"
                label="nome"
                placeholder="Selecione o cargo colegiado"
                :filterable="true">
              </v-select>
            </div>
          </div>
            <div class="flexbox" v-if="acompanhamentoForm.tipo_movimentacao">
              <div class="item">
                <label><b>Observação:</b></label>
                <textarea v-model="acompanhamentoForm.obs_acompanhamento" class="textarea" id="body" placeholder="Escreva uma observação aqui" @input="resize"></textarea>
              </div>
            </div>
        </div>        

        <!-- BLOCO 2: CONTROLE DE DATAS -->
        <h2 class="titulo-bloco">2. Monitoramento de Datas</h2>
        <div class="caixa-form item">
          
          <!-- Linha 1: Sempre aparece, pois as 3 datas são usadas na Exoneração e nas outras -->
          <div class="flexbox">
            <div class="item"><label><b>Chegada da Demanda:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.chegada_da_demanda" /></div>
            <div class="item"><label><b>Envio p/ Assinatura:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.envio_para_assinatura" /></div>
            <div class="item"><label><b>Assinatura:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.data_da_assinatura" /></div>
          </div>
          
          <!-- Linha 2: Some completamente na Exoneração -->
          <div class="flexbox" v-if="acompanhamentoForm.tipo_movimentacao !== 'exoneracao'">
            <div class="item"><label><b>Envio DIEEG:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.envio_para_dieeg" /></div>
            <div class="item"><label><b>Envio p/ Validação:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.envio_para_validacao" /></div>
            <div class="item"><label><b>Retorno Validação:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.retorno_validacao" /></div>
          </div>

          <!-- Linha 3: Some o Encaminhamento e Assembleia na Exoneração, mantendo apenas a Publicação -->
          <div class="flexbox">
            <div class="item" v-if="acompanhamentoForm.tipo_movimentacao !== 'exoneracao'"><label><b>Encaminhamento à Entidade:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.encaminhamento_entidade" /></div>
            <div class="item" v-if="acompanhamentoForm.tipo_movimentacao !== 'exoneracao'"><label><b>Assembleia:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.data_assembleia" /></div>
            <div class="item"><label><b>Data de Publicação:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.data_publicacao" /></div>
          </div>

          <!-- Linha 4: Some completamente na Exoneração -->
          <div class="flexbox" v-if="acompanhamentoForm.tipo_movimentacao !== 'exoneracao'">
            <div class="item"><label><b>Início do Mandato:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.inicio_mandato" /></div>
            <div class="item"><label><b>Fim do Mandato:</b></label><input type="date" v-model="acompanhamentoForm.acompanhamento_data_attributes.fim_mandato" /></div>
          </div>
          
        </div>

        <div class="bt-status" v-if="isEditing">
          <button
            type="button"
            :disabled="atualizandoStatus"
            @click="alternarStatusConclusao">
            {{ atualizandoStatus ? "Atualizando..." : (acompanhamentoForm.concluido ? "Reabrir Processo" : "Marcar como concluído") }}
          </button>
        </div>
        <div class="bt-salvar">
          <button id="botao-salvar" title="Salvar Movimentação" type="submit">
            <p id="conteudo-botao">{{ acompanhamentoForm.id ? "Atualizar" : "Salvar" }}</p>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import AcompanhamentoApi from '../../services/AcompanhamentoApi.js';
import BotaoVoltar from '../../components/BotaoVoltar.vue';
import MsgErroFormularios from '../MsgErroFormularios';

export default {
  name: 'AcompanhamentoForm',
  props: {
    acompanhamento: {
      type: Object,
      required: false,
    },
  },
  components: {
    BotaoVoltar,
    MsgErroFormularios,
    vSelect,
  },
  data() {
    return {
      carregando: false,
      atualizandoStatus: false,
      erro: false,
      isEditing: false,
      msgErros: {},
      acompanhamentoApi: null,
      bloquearNomeIndicado: this.acompanhamento && this.acompanhamento.nome_indicado ? true : (this.acompanhamento ? false : true),
      bloquearNomeDestituido: this.acompanhamento && this.acompanhamento.nome_destituido ? true : (this.acompanhamento ? false : true),
      acompanhamentoForm: this.acompanhamento ? { 
        ...this.acompanhamento,
        acompanhamento_data_attributes: this.acompanhamento.acompanhamento_data || {}
      } : {
        id: null,
        tipo_movimentacao: null,
        processo_sei: null,
        obs_acompanhamento: null,
        colegiado_id: null,           // Vai receber o ID da Categoria (Órgão)
        conselho_indicado_id: null,   // Vai receber o ID do Colegiado
        conselho_destituido_id: null, // Vai receber o ID do Colegiado
        cargo_indicado_id: null,
        cargo_destituido_id: null,
        nome_indicado: null,
        cpf_indicado: null,
        nome_destituido: null,
        cpf_destituido: null,
        acompanhamento_data_attributes: { /* ... suas datas normais aqui ... */ }
      },
      
      // Novas Listas
      categorias: [], // Puxa categorias_representativas
      conselhos: [],  // Puxa colegiados
      cargos: [],

      // Novos v-models
      selectedOrgaoGlobal: null, 
      selectedConselhoIndicado: null,
      selectedConselhoDestituido: null,
      selectedCargoIndicado: null,
      selectedCargoDestituido: null,      
    };
  },
  created() {
    this.isEditing = !!this.acompanhamentoForm.id;
    this.acompanhamentoApi = new AcompanhamentoApi();
    this.carregarConselhos();
    this.carregarOrgaosSGU();
    this.carregarCargos();

    if (this.isEditing && this.acompanhamentoForm.colegiado_id) {
      this.carregarConselhos(this.acompanhamentoForm.colegiado_id);
    }    
  },
  computed: {
    labelNomeSaida() {
      if (this.acompanhamentoForm.tipo_movimentacao === 'substituicao') return 'Nome Substituído:';
      if (this.acompanhamentoForm.tipo_movimentacao === 'exoneracao') return 'Nome Exonerado:';
      return 'Nome Destituído:';
    },    
    labelCpfSaida() {
      if (this.acompanhamentoForm.tipo_movimentacao === 'substituicao') return 'CPF Substituído:';
      if (this.acompanhamentoForm.tipo_movimentacao === 'exoneracao') return 'CPF Exonerado:';
      return 'CPF Destituído:';
    },
    conselhosFiltrados() {
      return this.conselhos;
    }
  },
  watch: {
    selectedOrgaoGlobal(novoValor, valorAntigo) {
      // 1. Primeiro, limpa a sujeira se o usuário trocar de opção
      if (valorAntigo && novoValor !== valorAntigo) {
        this.selectedConselhoIndicado = null;
        this.selectedConselhoDestituido = null;
        this.conselhos = [];
      }      
      // 2. Depois, dispara a busca lá no banco de dados passando o ID!
      if (novoValor && novoValor.id) {
        this.carregarConselhos(novoValor.id);
      } else {
        this.conselhos = []; 
      }
    },
    // Fica observando o CPF do Indicado
    'acompanhamentoForm.cpf_indicado'(novoValor) {
      if (!novoValor) return;
      const cpfLimpo = novoValor.replace(/\D/g, '');
      
      // Assim que bater 11 dígitos, dispara a busca!
      if (cpfLimpo.length === 11) {
        this.buscarDados(novoValor, 'indicado');
      }
    },
    
    // Fica observando o CPF do Destituído
    'acompanhamentoForm.cpf_destituido'(novoValor) {
      if (!novoValor) return;
      const cpfLimpo = novoValor.replace(/\D/g, '');
      
      // Assim que bater 11 dígitos, dispara a busca!
      if (cpfLimpo.length === 11) {
        this.buscarDados(novoValor, 'destituido');
      }
    }
  },
  methods: {
    async alternarStatusConclusao() {
      if (!this.acompanhamentoForm.id || this.atualizandoStatus) return;

      const novoStatus = !this.acompanhamentoForm.concluido;
      this.atualizandoStatus = true;
      this.erro = false;

      try {
        const acompanhamentoAtualizado = await this.acompanhamentoApi.atualizarStatusConclusao(
          this.acompanhamentoForm.id,
          novoStatus
        );
        this.acompanhamentoForm.concluido = acompanhamentoAtualizado.concluido;
      } catch (error) {
        console.error("Erro ao atualizar status do acompanhamento:", error);
        this.msgErros.geral = "Não foi possível atualizar o status do acompanhamento.";
        this.erro = true;
      } finally {
        this.atualizandoStatus = false;
      }
    },
    async buscarDados(cpf, tipoPessoa) {
      if (!cpf) return;
      const cpfLimpo = cpf.replace(/\D/g, '');
      
      // Se o usuário apagar o CPF, bloqueia o campo de nome novamente
      if (cpfLimpo.length !== 11) {
          if (tipoPessoa === 'indicado') this.bloquearNomeIndicado = true;
          if (tipoPessoa === 'destituido') this.bloquearNomeDestituido = true;
          return;
      }

      this.erro = false;
      this.verificarCarregamento = true;
      this.carregando = true;

      try {
          const dadosRh = await this.acompanhamentoApi.getDadosRhNet(cpfLimpo);
          if (dadosRh && Object.keys(dadosRh).length !== 0) {
              if (tipoPessoa === 'indicado') {
                  this.acompanhamentoForm.nome_indicado = dadosRh.nome;
                  this.bloquearNomeIndicado = true;
              } else if (tipoPessoa === 'destituido') {
                  this.acompanhamentoForm.nome_destituido = dadosRh.nome;
                  this.bloquearNomeDestituido = true;
              }
              return; 
          } 
      } catch (errRh) {
          try {
              const dadosReceita = await this.acompanhamentoApi.consultarCpfReceita(cpfLimpo);
              if (dadosReceita && dadosReceita.nome) {
                  if (tipoPessoa === 'indicado') {
                      this.acompanhamentoForm.nome_indicado = dadosReceita.nome;
                      this.bloquearNomeIndicado = true;
                  } else if (tipoPessoa === 'destituido') {
                      this.acompanhamentoForm.nome_destituido = dadosReceita.nome;
                      this.bloquearNomeDestituido = true;
                  }
              }
          } catch (errReceita) {
              console.warn("CPF não localizado em nenhuma das bases. Preenchimento manual liberado.");
                            
              if (tipoPessoa === 'indicado') {
                  this.bloquearNomeIndicado = false;
                  this.acompanhamentoForm.nome_indicado = ''; 
              } else if (tipoPessoa === 'destituido') {
                  this.bloquearNomeDestituido = false;
                  this.acompanhamentoForm.nome_destituido = '';
              }
          }
      } finally {
          this.carregando = false;
          this.verificarCarregamento = false;
      }
    },
    async carregarConselhos(orgaoId) {      
      if (!orgaoId) return;

      try {
        // Agora mandamos o ID para a API fazer o filtro pesado lá no banco
        const response = await this.acompanhamentoApi.getColegiados(orgaoId); 
        
        this.conselhos = response.map((item) => ({ 
          id: item.id,           
          nome: item.sigla ? `${item.nome} - ${item.sigla}` : item.nome, 
          orgao_id: item.orgao_id 
        }));

        if (this.isEditing) {
          if (this.acompanhamentoForm.conselho_indicado_id) {
            this.selectedConselhoIndicado = this.conselhos.find(o => o.id === this.acompanhamentoForm.conselho_indicado_id);
          }
          if (this.acompanhamentoForm.conselho_destituido_id) {
            this.selectedConselhoDestituido = this.conselhos.find(o => o.id === this.acompanhamentoForm.conselho_destituido_id);
          }
        }
      } catch (error) {
        console.error("Erro ao carregar conselhos:", error);
      }
    },
    async carregarOrgaosSGU() { 
      try {        
        const response = await this.acompanhamentoApi.getOrgaosOrigem(); 
        let listaOrgaos = response.data || response || [];
                
        this.categorias = listaOrgaos.map(item => ({ 
          id: item.id, 
          nome: item.sigla ? `${item.sigla} - ${item.nome}` : item.nome 
        }));

        if (this.isEditing && this.acompanhamentoForm.colegiado_id) {
          this.selectedOrgaoGlobal = this.categorias.find(c => c.id === this.acompanhamentoForm.colegiado_id);
        }
      } catch (error) {
        console.error("Erro ao carregar órgãos do SGU:", error);
      }
    },

    async carregarCargos() {
      try {
        const response = await this.acompanhamentoApi.getCargos();
                
        let listaCargos = response.resultados || response.cargos_colegiados || response.cargos || response.data || response || [];

        this.cargos = listaCargos.map(item => ({
          id: item.id,
          nome: item.nome
        }));

        if (this.isEditing) {
          if (this.acompanhamentoForm.cargo_indicado_id) {
            this.selectedCargoIndicado = this.cargos.find(c => c.id === this.acompanhamentoForm.cargo_indicado_id);
          }
          if (this.acompanhamentoForm.cargo_destituido_id) {
            this.selectedCargoDestituido = this.cargos.find(c => c.id === this.acompanhamentoForm.cargo_destituido_id);
          }
        }
      } catch (error) {
        console.error("Erro ao carregar cargos:", error);
      }
    },
    async enviarForm() {
      this.erro = false;
      
      // Órgão Global (Agora usa selectedOrgaoGlobal )
      if (this.selectedOrgaoGlobal !== null) {
        this.acompanhamentoForm.colegiado_id = this.selectedOrgaoGlobal.id;
      } else {
        this.acompanhamentoForm.colegiado_id = null;
      }

      // Conselho do Indicado (Antiga categoria_indicado)
      if (this.selectedConselhoIndicado !== null) {
        this.acompanhamentoForm.conselho_indicado_id = this.selectedConselhoIndicado.id;
      } else {
        this.acompanhamentoForm.conselho_indicado_id = null;
      }
      
      // Conselho do Destituído (Antiga categoria_destituido)
      if (this.selectedConselhoDestituido !== null) {
        this.acompanhamentoForm.conselho_destituido_id = this.selectedConselhoDestituido.id;
      } else {
        this.acompanhamentoForm.conselho_destituido_id = null;
      }

      // Cargos (Estes NÃO mudaram de nome, continuam iguais)
      if (this.selectedCargoIndicado !== null) {
        this.acompanhamentoForm.cargo_indicado_id = this.selectedCargoIndicado.id;
      } else {
        this.acompanhamentoForm.cargo_indicado_id = null;
      }
      
      if (this.selectedCargoDestituido !== null) {
        this.acompanhamentoForm.cargo_destituido_id = this.selectedCargoDestituido.id;
      } else {
        this.acompanhamentoForm.cargo_destituido_id = null;
      }

      // 2. SEGUNDO: Rodamos a validação
      let flag = this.validarForm(this.acompanhamentoForm);
      
      if (flag === 1) {
        this.erro = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // 3. TERCEIRO: Disparamos o salvamento para o Back-end
      try {
        await this.acompanhamentoApi.setAcompanhamento(this.acompanhamentoForm);
        this.$router.push({ name: 'Acompanhamentos' });
      } catch (err) {
        this.erro = true;
        this.msgErros.geral = "Ocorreu um erro ao salvar a movimentação. Verifique os dados e tente novamente.";
      }
    },
    validarForm(form) {
      let flag = 0;
      this.msgErros = {};
      
      // Validações Bloco 1 (Básicos)
      if (!form.tipo_movimentacao) { this.msgErros.tipo_movimentacao = 'O Tipo de Movimentação é obrigatório.'; flag = 1; }      
      
      // AQUI MUDOU: Agora checamos 'selectedOrgaoGlobal' em vez de 'selectedOrgao'
      if (!this.selectedOrgaoGlobal) { this.msgErros.colegiado_id = 'O Órgão é obrigatório.'; flag = 1; }
      
      if (['indicacao', 'substituicao', 'reconducao'].includes(form.tipo_movimentacao)) {
        if (!form.nome_indicado) { this.msgErros.nome_indicado = 'O Nome do Indicado é obrigatório.'; flag = 1; }
        if (!form.cpf_indicado || form.cpf_indicado.replace(/\D/g, '').length < 11) { this.msgErros.cpf_indicado = 'O CPF do Indicado é obrigatório e deve ser válido.'; flag = 1; }        
      }

      if (['destituicao', 'substituicao', 'exoneracao'].includes(form.tipo_movimentacao)) {
        if (!form.nome_destituido) { this.msgErros.nome_destituido = 'O Nome do ' + this.labelNomeSaida.replace('Nome ', '').replace(':', '') + ' é obrigatório.'; flag = 1; }
        if (!form.cpf_destituido || form.cpf_destituido.replace(/\D/g, '').length < 11) { this.msgErros.cpf_destituido = 'O CPF do ' + this.labelCpfSaida.replace('CPF ', '').replace(':', '') + ' é obrigatório e deve ser válido.'; flag = 1; }        
      }
      
      // NOVA REGRA: Bloqueia CPFs iguais em caso de Substituição
      if (form.tipo_movimentacao === 'substituicao' && form.cpf_indicado && form.cpf_destituido) {
        let cpfEntrada = form.cpf_indicado.replace(/\D/g, '');
        let cpfSaida = form.cpf_destituido.replace(/\D/g, '');

        if (cpfEntrada === cpfSaida && cpfEntrada.length === 11) {
          this.msgErros.cpf_indicado = 'O CPF do indicado não pode ser igual ao do substituído.';
          this.msgErros.cpf_destituido = 'O CPF do substituído não pode ser igual ao do indicado.';
          flag = 1;
        }
      }
      // Validações Bloco 2 (Cronologia das Datas aninhadas)
      const datas = form.acompanhamento_data_attributes;

      if (datas.data_da_assinatura && datas.envio_para_assinatura) {
        if (new Date(datas.data_da_assinatura) < new Date(datas.envio_para_assinatura)) {
          this.msgErros.data_da_assinatura = 'A data de assinatura não pode ser anterior à data de envio.';
          flag = 1;
        }
      }

      if (datas.retorno_validacao && datas.envio_para_validacao) {
        if (new Date(datas.retorno_validacao) < new Date(datas.envio_para_validacao)) {
          this.msgErros.retorno_validacao = 'O retorno da validação não pode ser anterior ao envio.';
          flag = 1;
        }
      }

      if (datas.fim_mandato && datas.inicio_mandato) {
        if (new Date(datas.fim_mandato) < new Date(datas.inicio_mandato)) {
          this.msgErros.fim_mandato = 'O fim do mandato não pode ser anterior ao seu início.';
          flag = 1;
        }
      }

      return flag;
    },
    possuiAsterisco(texto) {
      return '* ' + texto;
    },
    fecharErro() {
      this.erro = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/catalogoForm.scss";

.titulo-bloco {
  font-family: "Montserrat-Bold", "Montserrat", sans-serif;
  color: #005516;
  font-size: 1.05rem;
  margin: 1.25rem 0 0.65rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid #dde5e0;
}

.caixa-form .flexbox {
  display: flex;
  gap: 1.15rem 1.35rem;
  margin-bottom: 1.15rem;
  flex-wrap: wrap;

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 250px;
    gap: 0.35rem;
  }
}

.input-bloqueado {
  background-color: #e5e8e6 !important;
  color: #5a675f !important;
  cursor: not-allowed;
  pointer-events: none;
}

.select-padrao {
  width: 100%;
}
.wrapper .form.centro p.texto-asterisco {
  color: #005516 !important;
  font-size: 0.9rem !important;
  margin-bottom: 1rem !important;
  font-family: "Montserrat-Medium", sans-serif !important;
}
/* Organizar os radio buttons em coluna (abaixo do título) e alinhar à esquerda */
.radio {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 0.6rem;
}

.radio-label {
  margin: 0 !important;
  text-align: left;
  width: 100%;
}

.radio-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* Garante que os botões caiam para a linha de baixo se faltar espaço */
  gap: 0.5rem; /* Espaçamento entre cada opção (Indicação, Destituição...) */
}

.radio-item .options {
  display: flex;
  align-items: center;
}

.radio-item .options input {
  margin: 0;
  width: auto;
}

.bt-status {
  text-align: center;
  margin-top: 2rem;

  button {
    background-color: #ffffff;
    color: #005516;
    border: 1px solid #005516;
    font-size: 1rem;
    padding: 0.6rem 2rem;
    border-radius: 2rem;
    cursor: pointer;
    transition: background-color 0.3s;
    font-family: "Montserrat-Bold";

    &:hover {
      background-color: #e6f4ea;
    }

    &:disabled {
      cursor: wait;
      opacity: 0.7;
    }
  }
}

.bt-status {
  text-align: center;
  margin-top: 2rem;

  button {
    background-color: #ffffff;
    color: #005516;
    border: 1px solid #005516;
    font-size: 1rem;
    padding: 0.6rem 2rem;
    border-radius: 2rem;
    cursor: pointer;
    transition: background-color 0.3s;
    font-family: "Montserrat-Bold";

    &:hover {
      background-color: #e6f4ea;
    }

    &:disabled {
      cursor: wait;
      opacity: 0.7;
    }
  }
}

.radio-item .options label {
  margin: 0 0 0 0.3rem; /* Espaço entre a bolinha e a palavra */
  font-size: 0.85rem;
}
</style>
